type NotificationVersionSource = {
  u_version?: { value?: string }
}

export function isNotificationVersionV1(
  notification?: NotificationVersionSource | null
): boolean {
  return notification?.u_version?.value?.toLowerCase() === 'v1'
}

/** V1 não utiliza frequência na unidade; remove valor legado incorreto do payload. */
export function withoutProbabilityOccurrenceForV1<T extends Record<string, unknown>>(
  notification: T
): T {
  if (!isNotificationVersionV1(notification)) {
    return notification
  }

  const { u_probability_occurence: _, ...rest } = notification
  return rest as T
}
